const months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
const d = new Date();
let today = months[d.getMonth()];

const questions = {

    "january": {
        "q1": ["Travis Barker was drumming with the ska punk group The Aquabats in 1994 when he filled in for what band which soon became his full-time gig?", "Blink 182"],
        "q2": ["Everyone knows Elvis' home was Graceland in Memphis, but in what Mississippi town was he born?", "Tupelo"],
        "q3": ["Taking it waaay back: what composer of Eine Kleine Nachtmusik (and lesser-known songs about farts and butts) was rumored to have been poisoned by rival Salieri when he died in 1791 at the age of 35? (Hint: he was the subject of the only German-language #1 hit on the Billboard Hot 100 thanks to Falco's \'Rock Me ____\' in 1985)", "Wolfgang Amadeus Mozart"],
        "bonus": "Thanks for playing, if YOU have a trivia question to share or any other feedback, please send it to Will!"
    }
};
document.getElementById("q1").innerHTML = questions[today].q1[0]
document.getElementById("q2").innerHTML = questions[today].q2[0]
document.getElementById("q3").innerHTML = questions[today].q3[0]
function checkAnswer() {
    document.getElementById("submitanswers").style.display = "none";
    document.getElementById("copyscore").style.display = "";
    const correctAnswer = [questions[today].q1[1], questions[today].q2[1], questions[today].q3[1]]; // Define the correct answer
    const userAnswer = [document.getElementById("answerInput1").value.replace(/ /g, ''), document.getElementById("answerInput2").value.replace(/ /g, ''), document.getElementById("answerInput3").value.replace(/ /g, '')]
    const userAnswer1 = document.getElementById("answerInput1").value.replace(/ /g, ''); // Get user's input and remove whitespace
    const userAnswer2 = document.getElementById("answerInput2").value.replace(/ /g, ''); // Get user's input and remove whitespace
    const userAnswer3 = document.getElementById("answerInput3").value.replace(/ /g, ''); // Get user's input and remove whitespace
    const feedbackElement = document.getElementById("feedback");
    const answerElement = document.getElementById("answers");
    const bonusElement = document.getElementById("bonus");
    score = ""
    for (var i = 0; i < 3; i++) {

        let guess = userAnswer[i].toLowerCase().replace(/[ '.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");
        let finalGuess = guess.replace(/\s{2,}/g, " ");
        let ans = correctAnswer[i].toLowerCase().replace(/[ '.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");
        let finalAns = ans.replace(/\s{2,}/g, " ");
        if (userAnswer[i] == "") {
            score += "❌";
        }
        else {
            if (finalGuess.includes(finalAns) || finalAns.includes(finalGuess)) {
                score += "✅";
            }
            else {
                score += "❌";
            }
        }
    }
    // navigator.clipboard.writeText('Sound Pro Trivia ' + '\n' +score );
    feedbackElement.textContent = score;
    answerElement.textContent = "The correct answers were " + correctAnswer[0] + ", " + correctAnswer[1] + ", and " + correctAnswer[2];
    // bonusElement.textContent = questions[today].bonus

};
// let thismonth = d.getMonth() + 1
async function copyScore(score) {
    try {
        await navigator.clipboard.writeText('Sound Pro Trivia ' + '\n' +score );
        console.log('Text copied to clipboard successfully!'+score);
    } catch (err) {
        console.error('Failed to copy text: ', err);
    }
}
